<!-- @veltra/icons generated sha256:03958c134e1e2d9b gen:8 source:src/svg/normal/calendar.svg -->
<script setup lang="ts">
defineOptions({ name: 'Calendar' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M10 3H6v-.994a.51.51 0 0 0-.504-.506h-.011A.493.493 0 0 0 5 2.006V3H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2v-.994a.51.51 0 0 0-.504-.506h-.011a.493.493 0 0 0-.485.506zM5.485 5h.011A.506.506 0 0 0 6 4.496V4h4v.496a.49.49 0 0 0 .485.504h.011A.49.49 0 0 0 11 4.515V4h2v2H3V4h2v.496A.49.49 0 0 0 5.485 5M3 7h10v6H3z"
    />
  </svg>
</template>
